<template>
  <div>
    <div class="pega-interview-header">
      プレビュー
    </div>
    <div class="user-preview">
      <div
        id="content1"
        class="content detail-content"
      >
        <div
          class="content-inner single-column"
          style="margin: 0 auto;"
        >
          <div class="main-content">
            <main role="main">
              <header class="mod-page-title">
                <p class="thumb">
                  <img
                    v-if="company.logoId"
                    :src="`${ userEndPoint }/image?id=${ company.logoId }`"
                    width="130"
                    height="40"
                    data-test="logo"
                  >
                </p>
                <h1 data-test="interview-job-title">
                  {{ company.name }}、××職の面接情報
                </h1>
                <p
                  class="page-lead"
                  data-test="interview-job-content"
                >
                  {{ company.name }}、××職の面接情報ページです。面接で質問される内容やNGワード、SPIのような能力試験、当日の服装などの情報を確認できます。面接対策にお役立てください。<br><br>
                  <span class="color-strong weight-bold">この面接情報ページは掲載スタート時の情報となります。また、拠点が複数ある場合や企業の選考状況などにより、内容が変更となる場合もありますので、ご了承くださいませ。</span><br>
                  <span>このページの内容については求人ページに記載されている企業の連絡先にお問い合わせください。</span>
                </p>
              </header>
              <div class="detail-local-nav min_nav">
                <ul>
                  <li
                    class="js-equal-heights"
                    style="height: 42px;"
                  >
                    <a
                      href="javascript:void(0)"
                      data-way="38"
                    >募集情報
                    </a>
                  </li>
                  <li
                    class="current js-equal-heights"
                    style="height: 42px;"
                  >
                    <strong>面接情報</strong>
                  </li>
                </ul>
              </div>
              <section class="section mod-job-detail pt10">
                <section class="section">
                  <h3 class="mod-title-lv2">
                    対象求人
                  </h3>
                  <div class="inner pl20">
                    <p>ここに求人名称が記載されます</p>
                  </div>
                </section>
                <section class="section">
                  <h3 class="mod-title-lv2">
                    募集背景
                  </h3>
                  <div class="inner pl20">
                    <p>ここに求人の募集背景が記載されます</p>
                  </div>
                </section>
              </section>
              <template v-if="isFetchedInterviewCountermeasure">
                <interview-preview-selection-flow
                  :interview-countermeasure="interviewCountermeasure"
                  :user-end-point="userEndPoint"
                />
                <interview-preview-interview-content
                  :interview-countermeasure="interviewCountermeasure"
                  :user-end-point="userEndPoint"
                />
              </template>
              <section class="mod-button-holder">
                <ul>
                  <li class="form-btn">
                    <a
                      class="mod-button search js-over"
                      href="javascript:void(0)"
                    ><span>求人を見る</span></a>
                  </li>
                  <li class="register-btn">
                    <a
                      href="javascript:void(0)"
                      class="mod-button default-large register js-over"
                    ><span>検討中リストに入れる</span></a>
                  </li>
                </ul>
              </section>
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import InterviewPreviewSelectionFlow from '@/components/organisms/InterviewPreviewSelectionFlow'
import InterviewPreviewInterviewContent from '@/components/organisms/InterviewPreviewInterviewContent'
import { mapActions } from 'vuex'

const USER_URL = process.env.USER_ENDPOINT

export default {
  components: {
    InterviewPreviewSelectionFlow,
    InterviewPreviewInterviewContent
  },
  data () {
    return {
      interviewCountermeasure: {},
      company: {}
    }
  },
  computed: {
    userEndPoint: () => USER_URL,
    isFetchedInterviewCountermeasure () {
      return Object.keys(this.interviewCountermeasure).length > 0
    }
  },
  created () {
    this.fetchInterviewCountermeasure()
    this.fetchCompany()
    this.fetchInterviewCheckpointCategories()
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    fetchInterviewCountermeasure () {
      this.$http.secured.get(`/interview_countermeasures/${this.$route.params.interviewCountermeasureId}`).then(response => {
        this.$set(this, 'interviewCountermeasure', response.data)
      })
    },
    fetchCompany () {
      this.$http.secured.get('/company').then(response => {
        this.$set(this, 'company', response.data)
      })
    },
    fetchInterviewCheckpointCategories () {
      this.storeMaster('interviewCheckpointCategories')
    }
  }
}
</script>
